import { firebaseInit } from './firebase';
import '../../public/static/css/event.css';
const initialize = () => {
    firebaseInit();
};
initialize();
